import { useQuery } from '@tanstack/react-query';

import { marketStatsApi, type PublicMarketStats } from '../lib/api-client';

export function usePublicMarketStats() {
  return useQuery<PublicMarketStats>({
    queryKey: ['market-stats', 'public'],
    queryFn: () => marketStatsApi.publicStats(),
    staleTime: 5 * 60 * 1000, // 5 min — backend caches for 10
    refetchOnWindowFocus: false,
  });
}
